import api from '../../services/service_income'
import Swal from 'sweetalert2'
import Pagination from 'vue-pagination-2'

export default {
  components: {
    Pagination
  },
  data () {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      search: '',
      income_list: [],
      zone_list: [],
      zone: '',
      activePage: 1,
      allItem: 0,
      ItemPerpage: 10,
      month: this.dateMonth(new Date()),
      md_menu: 1,
      md_data: {},
      md_water_data: {}
      // month: this.dateMonth(new Date().setMonth(8))
    }
  },
  created () {
    this.checkUser()
  },
  methods: {
    callback: function (page) {
      this.activePage = page
      this.searchUser()
    },
    searchBack () {
      if (this.activePage > 1) {
        this.activePage -= 1
        this.searchHome()
      }
    },
    searchNext () {
      if (this.activePage <= Math.ceil(this.allItem / this.ItemPerpage)) {
        this.activePage += 1
        this.searchHome()
      }
    },
    checkSize () {
      this.activePage = 1
      if (this.$store.state.screenWidth < 600) {
        this.ItemPerpage = 6
      } else {
        this.ItemPerpage = 12
      }
      this.income_list = []
    },
    moreList () {
      this.activePage += 1
      this.searchHome()
    },
    getZoneAll () {
      var obj = {
        search: '',
        active_page: 1,
        per_page: 100000000
      }
      api.getZone(obj, this.header,
        result => {
          if (result.response === true) {
            this.zone_list = result.data.pagination
          } else {
            Swal.fire('ดึงข้อมูลสิทธิ์', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    searchHome () {
      var obj = {
        search: this.search,
        zone: this.zone,
        date: this.month,
        active_page: this.activePage,
        per_page: this.ItemPerpage
      }

      this.$store.state.isLoading = true
      api.searchIncome(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.income_list = result.data.pagination
            this.allItem = result.data.count
            console.log(result.data)
          } else {
            Swal.fire('ดึงข้อมูลผู้ใช้งาน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    editIncome (id) {
      if (this.$store.state.user.role_id === '4') {
        this.getWaterIncome(id)
      } else {
        this.$router.push({ name: 'formincome', params: { id: id } })
      }
    },
    getWaterIncome (id) {
      this.$store.state.isLoading = true
      api.IncomeDetail(id,
        this.header,
        result => {
          if (result.response === true) {
            $('#formwater').modal('show')
            this.getWater(result.data.home_id)
            this.md_data = result.data
          } else {
            Swal.fire('ดึงข้อมูลหนี้สินรายเดือน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getWater (homeId) {
      this.$store.state.isLoading = true
      api.getWaterHistory(homeId,
        this.header,
        result => {
          if (result.response === true) {
            this.md_water_data = result.data
          } else {
            Swal.fire('ดึงข้อมูลประวัติการใช้น้ำ', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    addWater () {
      this.md_data.water_income.push(
        {
          water_income_id: '',
          water_income_text: 'มิเตอร์ที่ ' + (this.md_data.water_income.length + 1),
          water_income_unit: 0,
          water_total_last_unit: 0,
          water_income_price: 0,
          history_income_id: this.md_data.history_income_id
        }

      )
    },
    removeWater (index) {
      this.md_data.water_income.splice(index, 1)
    },
    checkWater (index) {
      var last = this.md_data.water_income[index]['water_total_last_unit']
      var current = this.md_data.water_income[index]['water_income_unit']
      const limit = this.md_data.water_income[index]['limit_water_unit']
      if (parseInt(last) > parseInt(current)) {
        Swal.fire('กรอกข้อมูลน้ำ', 'ท่านต้องกรอกยอดมิตเตอร์ให้มากกว่ายอดเดิม', 'warning')
        this.md_data.water_income[index]['water_income_unit'] = this.md_data.water_income[index]['water_total_last_unit']
      }

      if ((parseInt(current) - parseInt(last)) > parseInt(limit)) {
        Swal.fire({
          title: 'กรอกข้อมูลน้ำ',
          text: 'ท่านต้องกรอกยอดมิตเตอร์เกินกำหนด ท่านต้องการใช้ยอดที่กรอกเข้ามาหรือไม่ ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            this.md_data.water_income[index]['water_income_unit'] = this.md_data.water_income[index]['water_income_unit']
          } else {
            this.md_data.water_income[index]['water_income_unit'] = ''
          }
        })
      }
    },
    save () {
      $('#formwater').modal('hide')
      this.$store.state.isLoading = true
      api.updateIncome(this.md_data,
        this.header,
        result => {
          if (result.response === true) {
            Swal.fire('บันทึกข้อมูลหนี้สินรายเดือน', result.data, 'success')
            this.searchHome()
          } else {
            Swal.fire('บันทึกข้อมูลหนี้สินรายเดือน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.checkSize()
    this.searchHome()
    this.getZoneAll()
    // eslint-disable-next-line no-undef
    $('body').on('hidden.bs.modal', '.modal', function () {
      // eslint-disable-next-line no-undef
      $(this).removeData('bs.modal')
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/incomehome.js